<template>
  <div class="ap-genart-search">
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td style="width:220px" v-loading="loadingGen">
            <div style="padding:16px;background:#F6F7F9;">
              <SearchField placeholder="零件类目名称" :small="true" :value.sync="genCmdtyNameLike" @submit="searchGenCmdty"></SearchField>
            </div>
            <div style="height:602px;overflow:auto">
              <div class="list-group list-group-bordered" v-for="it in records" :key="it.sourceId">
                <a
                  class="list-group-item list-group-item-action text-truncate"
                  style="padding:16px;"
                  :class="{'active': genCatId == it.sourceId}"
                  @click="getGenCmdties(it.sourceId)"
                >{{it.name}}</a>
              </div>
            </div>
          </td>
          <td v-loading="loadingGenList">
            <div class="gen-list-wrap">
              <div style="font-size:18px;padding:18px 0;">{{this.genCatName}}</div>
              <div class="list-wrap">
                <div class="genart-items clearfix">
                  <div class="genart-item float-left" v-for="it in genCmdties" :key="it.id">
                    <a @click="viewList(it)">
                      <div class="img-wrap">
                        <img class="img" :src="getImgUrl(it.pictureUri)" alt />
                      </div>
                      <div class="text">
                        <div class="text-truncate">{{it.name}}</div>
                        <div class="art-count">{{it.amount}}</div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import SearchField from "@components/SearchField.vue";

export default {
  components: {
    SearchField
  },
  data() {
    return {
      records: [],
      genCmdties: [],
      genCatId: "",
      genCatName: "",
      genCmdtyNameLike: "",
      loadingGen: false,
      loadingGenList: false
    };
  },
  created() {
    this.getData();
    document.title = "51 AUTOPARTS 以零件类目查询";
  },
  methods: {
    viewList(it) {
      window.open("#/genartsearch/" + it.sourceId + "/" + encodeURIComponent(it.name), "_blank");
    },
    sort(key) {
      return function(a, b) {
        return a[key] - b[key];
      };
    },
    getData() {
      this.loadingGen = true;
      this.$list(
        "/dmhs/genCats/query",
        {},
        {
          success(res) {
            this.loadingGen = false;
            if (!res.length) return $msg.warning("暂无数据！");
            this.records = res.sort(this.sort("seq"));
            this.genCatId = res[0].sourceId;
            this.genCatName = res[0].name;
            this.getGenCmdties(this.genCatId);
          }
        }
      );
    },
    getGenCmdties(id) {
      this.genCatId = id;
      this.loadingGenList = true;
      this.$get(
        "/dmhs/genCats/get/" + this.genCatId,
        {},
        {
          success(res) {
            this.loadingGenList = false;
            this.genCatName = res.name;
            this.genCmdties = res.genCmdtyList.sort(this.sort("seq"));
          }
        }
      );
    },
    searchGenCmdty() {
      this.genCatId = "";
      this.loadingGenList = true;
      this.$post(
        "/dmhs/genCmdties/query",
        { nameLike: this.genCmdtyNameLike },
        {
          success(res) {
            this.loadingGenList = false;
            this.genCmdties = res;
            this.genCatName = "";
          }
        }
      );
    }
  }
};
</script>

<style lang="less">
.ap-genart-search {
  .table-bordered,
  .table-bordered td,
  .table-bordered th {
    border-color: #e4e4e4;
  }
  tbody td {
    padding: 0;
  }
  .gen-list-wrap {
    background: #f6f7f9;
    height: 665px;
    overflow: auto;
    padding-left: 25px;
    display: flex;
    flex-direction: column;
    .list-wrap {
      overflow: auto;
      .genart-item {
        width: 184px;
        margin-right: 15px;
        margin-bottom: 25px;
        a {
          display: block;
          text-align: center;
          border: 2px solid #fff;
          background: #fff;
          .img-wrap {
            display: inline-block;
            width: 148px;
            height: 100px;
            margin-top: 15px;
            .img {
              width: 100%;
              height: 100%;
            }
          }
          &:hover {
            border-color: #999;
          }
          .text {
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            .text-truncate {
              color: #333;
            }
            .art-count {
              font-size: 12px;
              color: #db5158;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
</style>